import * as React from "react";
import { Box } from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { TimelineTableCols } from "./col";
import { lightTable } from "../../../../../../../../styles/muiProps";

export default function SubMaterialTable({ timeline }) {
  const data = timeline
    .map((r) => {
      function parseNativeDate(str) {
        const date = new Date(str);
        return isNaN(date) ? null : date;
      }

      function formatToYYYYMMDD(date) {
        if (!(date instanceof Date) || isNaN(date)) return "";

        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");

        return `${yyyy}-${mm}-${dd}`;
      }

      return { ...r, date: formatToYYYYMMDD(parseNativeDate(r.date)) };
    })
    .sort((a, b) => new Date(a.date) - new Date(b.date));

  const table = useMaterialReactTable({
    data,
    columns: TimelineTableCols,
    ...lightTable,
    getRowId: (originalRow) => originalRow.id,

    enableStickyHeader: true,
    enableStickyFooter: true,
    muiTableBodyCellProps: {
      sx: {
        textAlign: "center",
        border: "1px solid rgba(81, 81, 81, .1)",
        padding: "10px",
      },
    },
    muiTableFooterCellProps: {
      sx: {
        border: "0.5px solid rgba(81, 81, 81, .1)",
        // fontStyle: 'italic',
        fontWeight: "normal",
        padding: "10px",
        backgroundColor: "#f3f1fe",
      },
    },
  });

  return (
    <Box sx={{ backgroundColor: "#fff" }}>
      <MaterialReactTable table={table} />
    </Box>
  );
}
